import { registrationEmailUtmParameters } from "../send/sendRegisterEmail"
import { thankYou } from "./subDefinitions/emailComponents"
import moment from "moment"
import "moment/locale/cs"
import { generateButtonPdfVoucherLink } from "./subDefinitions/generateButtonPdfVoucherLink"
import { generateEmailCallToActionButton, generateEmailParagraph, generateEmailText, spaceDivider } from "../generateEmailParagraph"
import { getOpenCoursesOffer } from "./subDefinitions/openCoursesOffer"

moment.locale("cs")

const emailDefinition1RegisterIntoInPersonFreeCourseSubject = "Potvrzení registrace, Vzdělání budoucnosti"

export const emailDefinition1RegisterIntoInPersonFreeCourse = (
  courseTitle: string,
  when: string,
  courseDetailPageUrl: string,
  courseListOffer: string,
  downloadPdfVoucherUrl?: string
): { body: string; subject: string } => ({
  body: `
  ${generateEmailParagraph("Dobrý den, ")}
  
  ${generateEmailParagraph(
    `s radostí Vám oznamujeme, že jste úspěšně zaregistrovaný(á) do bezplatného kurzu <strong>"${courseTitle}"</strong>, která byla provedena dne ${moment().format(
      "l"
    )}. Chystáme pro Vás zajímavý program, a těšíme se na Vaši účast.`
  )}
  
  ${generateEmailParagraph(
    `Pokud jste spokojeni s tím, co nabízíme v našich kurzech, bylo by pro nás velkou ctí, kdybyste o našich programech informovali své blízké a přátele. Pokud máte ve svém okolí někoho, koho by mohla naše nabídka zaujmout, neváhejte mu poslat odkaz na naši webovou stránku.`
  )}
  
  ${generateEmailText(`<strong>Datum a čas konání kurzu:</strong>`)}
  ${generateEmailParagraph(when)}
  
  ${generateEmailText(`<strong>Další kroky:</strong>`)}
  ${generateEmailParagraph(
    `Jakmile se přiblíží termín kurzu, zašleme Vám připomínku - e-mail s dalšími důležitými informacemi, včetně detailních instrukcí, jak se připojit pomocí odkazu.`
  )}
  
  ${generateEmailParagraph(`Více informací o kurzu naleznete na našich webových stránkách.`)}
  
  ${generateEmailCallToActionButton("Více informací o kurzu", "Více informací o kurzu", `${courseDetailPageUrl}${registrationEmailUtmParameters}`)}
  
  ${generateButtonPdfVoucherLink(downloadPdfVoucherUrl)}
  
  ${spaceDivider}
  ${getOpenCoursesOffer(courseListOffer)}
  
  ${thankYou}
`,
  subject: emailDefinition1RegisterIntoInPersonFreeCourseSubject
})
